import { render, staticRenderFns } from "./CarbonCostByYear.vue?vue&type=template&id=60d870bb"
import script from "./CarbonCostByYear.vue?vue&type=script&lang=js"
export * from "./CarbonCostByYear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports